import styled from 'styled-components'
import { Grid } from '@material-ui/core'

export const GridContainer = styled(Grid)`
  margin-bottom: 4rem;
`
export const GridIconCard = styled(Grid)``
